<div class="container" style="margin-top: 6rem;">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body p-4">
            <form [formGroup]="registerForm" (ngSubmit)="daftar()" autocomplete="off">
                <div class="mt-3 mb-5 text-center">
                    <h3 style="color:var(--warna-2)">Create an account</h3>
                </div>
                        <!-- Name Input -->
                <div class="mb-3">
                    <input 
                    type="text" 
                    class="form-control" 
                    id="name_reg"
                    formControlName="name_reg"
                    [ngClass]="{'is-invalid': submitted && registerForm.get('name_reg')?.invalid}"
                    placeholder="Full Name"
                    autocomplete="name"
                    >
                    <div class="text-danger" *ngIf="submitted">
                    <div *ngIf="hasError(registerForm, 'name_reg', 'required')">Please enter your name</div>
                    </div>
                </div>

                <!-- Email Input -->
                <div class="mb-3">
                    <input 
                    type="email_reg" 
                    class="form-control" 
                    id="email_reg"
                    formControlName="email_reg"
                    [ngClass]="{'is-invalid': submitted && (hasError(registerForm, 'email_reg', 'required') || hasError(registerForm, 'email_reg', 'email'))}"
                    placeholder="Email"
                    autocomplete="email"
                    >

                    <div class="text-danger" *ngIf="submitted">
                    <div *ngIf="hasError(registerForm, 'email_reg', 'required')">Please enter your email</div>
                    <div *ngIf="hasError(registerForm, 'email_reg', 'email')">Please enter a valid email</div>
                    </div>
                </div>


                 <!--Password Input -->

                 <div class="mb-3">  
                    <div class="input-group">
                    <input type="password" style="display:none">
                    <input 
                    [type]="isPasswordVisible ? 'text' : 'password'" 
                    class="form-control" 
                    id="password_reg"
                    formControlName="password_reg"
                    [ngClass]="{'is-invalid': submitted && (hasError(registerForm, 'password_reg', 'required') || 
                                 hasError(registerForm, 'password_reg', 'minlength') ||
                                 hasError(registerForm, 'password_reg', 'invalidPassword')
                                 )}"
                    placeholder="Password"
                    autocomplete="new-password"
                    >

                    <i 
                    class="fa text-secondary" 
                    [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" 
                    (click)="togglePasswordVisibility()" 
                    style="position: absolute; top: 35%; right: 10px; cursor: pointer; z-index: 5;" 
                    aria-hidden="true">
                  </i>
                   </div>
                    <div class="text-danger" *ngIf="submitted">
                    <div *ngIf="hasError(registerForm, 'password_reg', 'required')">Please enter your password</div>
                    <div *ngIf="hasError(registerForm, 'password_reg', 'minlength')"> Password must be at least 6 characters long.</div>
                    <div *ngIf="hasError(registerForm, 'password_reg', 'invalidPassword')">  Password must contain at least one uppercase letter and one number.</div>    
                </div>
                </div>

                <!-- Konfirmasi Password Input -->
                <div class="mb-3">
                  <div class="input-group">
                    <input type="password" style="display:none">
                    <input 
                    [type]="isPasswordVisible2 ? 'text' : 'password'"  
                    class="form-control" 
                    id="confirmPassword"
                    formControlName="confirmPassword"
                    [ngClass]="{'is-invalid': submitted && (hasError(registerForm, 'confirmPassword', 'required') || 
                                    hasError(registerForm, 'confirmPassword', 'passwordsMismatch')
                                    )}"
                    placeholder="Confirm Password"
                    autocomplete="new-password"
                    >
                    <i 
                    class="fa text-secondary" 
                    [ngClass]="isPasswordVisible2 ? 'fa-eye-slash' : 'fa-eye'" 
                    (click)="togglePasswordVisibility2()" 
                    style="position: absolute; top: 35%; right: 10px; cursor: pointer; z-index: 5;" 
                    aria-hidden="true">
                  </i>
                </div>
                <div class="text-danger" *ngIf="submitted">
                <div *ngIf="hasError(registerForm, 'confirmPassword', 'required')">Please enter your confirm password</div>
                <div *ngIf="registerForm.hasError('passwordsMismatch')">Passwords do not match.</div>
                </div>
                </div>
            
                <!-- Google reCAPTCHA -->
                <div class="mb-3">
                    <ngx-recaptcha2 #captchaElem
                    [siteKey]= recaptchaSiteKey
                    formControlName="recaptcha"
                    [ngClass]="{'is-invalid': submitted && registerForm.get('recaptcha')?.invalid}"                 
                    >
                    </ngx-recaptcha2>
                    
                    <div class="text-danger" *ngIf="submitted">
                    <div *ngIf="hasError(registerForm, 'recaptcha', 'required')">Please verify that you are not a robot</div>
                    </div>

                    <!-- <div *ngIf="submitted && !recaptchaVerified" class="text-danger">
                    Please verify that you are not a robot
                    </div> -->
                </div>

                <button 
                type="submit" 
                class="btn btn-primary w-100" 
                [disabled]="isLoading"
                >
                <span *ngIf="!isLoading">Continue</span>
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </form>
          </div>
        </div>
      </div>
    </div>
</div>
